import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { Weddings } from '../../Weddings';
import type { Agent } from '../Agents';
import type { IMemory } from './Memories.types';

@Identifiable
@Timestampable
export class Memory extends AbstractDocument<IMemory> {
  readonly collections = {};

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}

export class Memories extends AbstractCollection<Memory, IMemory> {
  static path = 'memories';

  constructor(document: Agent) {
    super(document.collection(Memories.path), Memory);
  }

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}
